import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import { useMobile } from "../../../hooks/useMobile";

function NtMobileTopFeatureSection(props) {
  const isMobile = useMobile();
  const renderBox = (title, message, containerStyle) => {
    return (
      <View
        style={[
          {
            flex: 1,
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            flexDirection: "row",
            alignItems: "center",
            padding: 18,
            borderRadius: 15,
          },
          containerStyle,
        ]}
      >
        <Image
          style={[
            {
              width: 150,
              height: 300,
              resizeMode: "contain",
            },
          ]}
          source={require("../../../assets/images/marketing/7afffde683a9bd23580f12ed3b03d5a71d7a944e.png")}
        />

        <View style={{ flex: 1, marginLeft: 15 }}>
          <NtSectionTitle style={{ textAlign: "left" }}>{title}</NtSectionTitle>
          <NtSectionDescription style={{ marginTop: 15 }}>
            {message}
          </NtSectionDescription>
        </View>
      </View>
    );
  };
  return (
    <NtMarketingSectionContainer
      style={[styles.container, isMobile ? { height: 900 } : {}]}
      backgroundImage={require("../../../assets/images/marketing/d57b984d313cf86ca92f895da1bc541f149e7f7e.jpg")}
    >
      <NtSectionTitle style={{ textAlign: "left", marginTop: 60 }}>
        TOP FEATURES
      </NtSectionTitle>
      <NtSectionDescription style={{ marginTop: 8 }}>
        Have a NT Connect ezLINQ? Use your ezLINQ number while on-the-go. Just
        like using your regular home phone to call anyone.
      </NtSectionDescription>
      <View
        style={{ marginTop: 40, flexDirection: isMobile ? "column" : "row" }}
      >
        {renderBox(
          "Free Unlimited Worldwide",
          "All calls between NT Connect users are always free & unlimited anywhere in the world with App-to-App and App-to-ezLINQ calling",
          { marginRight: isMobile ? 0 : 10, marginBottom: isMobile ? 10 : 0 }
        )}

        {renderBox(
          "Go Mobile",
          "Have a NT Connect ezLINQ? Use your ezLINQ number while on-the-go. Just like using your regular home phone to call anyone.",
          {}
        )}
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 600,
  },
});

export default NtMobileTopFeatureSection;
